/**
 * @author Samuel Gonzalez
 * Proposito: Establece las rutas de la página principal, donde carga
 *            el contenido
 */

import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { ConditionsComponent } from './pages/conditions/conditions.component';
import { CatalogoComponent } from './pages/catalogo/catalogo.component';
import { ScoreComponent } from './pages/score/score.component';
import { HistoryComponent } from './pages/history/history.component';
import { CartComponent } from './pages/cart/cart.component';
import { ContactComponent } from './pages/contact/contact.component';
import { CatalogoLudicoComponent } from './pages/catalogoludico/catalogoludico.component';
import { OutServiceComponent } from './pages/outservice/outservice.component';

export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    { path: 'outservice', component: OutServiceComponent },
    { path: 'login', component: LoginComponent, data: {title:'Login'} },
    { path: 'register', component: LoginComponent, data: {title:'Registro'} },
    { path: 'home', component: HomeComponent, data: {title:'Home'}, children:[
        {path: '', component: ScoreComponent, data: {title:'Inicio'}},
        {path: 'conditions', component: ConditionsComponent, data: {title:'Condiciones'}},
        {path: 'catalogo', component: CatalogoComponent, data: {title:'Silvicola'}},
        {path: 'catalogoludico', component: CatalogoLudicoComponent, data: {title:'Ludico'}},
        {path: 'score', component: ScoreComponent, data: {title:'Inicio'}},
        {path: 'history', component: HistoryComponent, data: {title:'Movimientos'}},
        {path: 'cart', component: CartComponent, data: {title:'Carrito'}},
        {path: 'contact', component: ContactComponent, data: {title:'Contacto'}}
    ]}
];